var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import Tooltip from 'devextreme/ui/tooltip';
import { v4 as uuidv4 } from 'uuid';
let DinapsisIconTooltip = class DinapsisIconTooltip extends LitElement {
    constructor() {
        super(...arguments);
        this.tooltip = undefined;
        /**
         * A property that is used to generate unique tooltip id
         */
        this.idTooltip = `toolip-${uuidv4()}`;
        /**
         * A property that is used to generate unique tooltip id
         */
        this.idIcon = `icon-${uuidv4()}`;
    }
    createRenderRoot() {
        return this;
    }
    firstUpdated() {
        const container = document.getElementById(this.idTooltip);
        if (container) {
            this.tooltip = new Tooltip(container);
            this.tooltip.option('target', `#${this.idIcon}`);
            if (this.data.tooltipEvent) {
                if (this.data.tooltipEvent === 'hover') {
                    this.tooltip.option('showEvent', 'mouseenter');
                    this.tooltip.option('hideEvent', 'mouseleave');
                }
                else if (this.data.tooltipEvent === 'click') {
                    this.tooltip.option('showEvent', 'click');
                    this.tooltip.option('hideOnOutsideClick', true);
                }
            }
            this.tooltip.option('position', 'bottom');
            this.tooltip.option('contentTemplate', this.data.text);
            if (this.width) {
                this.tooltip.option('maxWidth', this.width);
            }
            else {
                this.width = '25%';
                this.tooltip.option('maxWidth', this.width);
            }
            this.isInsideLateralSliderPanel();
        }
    }
    /**
     * The function checks if an element is inside a lateral slider panel and hides a tooltip when the
     * lateral container is scrolled.
     */
    isInsideLateralSliderPanel() {
        var _a;
        const dinapsisLateralSliderPanel = document.querySelector('dinapsis-lateral-slider-panel');
        if (!dinapsisLateralSliderPanel)
            return;
        const dinapsisLateralContainer = (_a = dinapsisLateralSliderPanel.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#dinapsis-lateral-container');
        if (!dinapsisLateralContainer)
            return;
        const iconTooltip = dinapsisLateralSliderPanel.querySelector(`#${this.idTooltip}`);
        if (!iconTooltip)
            return;
        dinapsisLateralContainer.addEventListener('scroll', () => {
            if (!this.tooltip)
                return;
            this.tooltip.hide();
        });
    }
    /**
     * If any property has changed when finish update this method is called an
     * depending on wich property has been modified,
     * it executes its update method
     * @param changedProperties - Map<string, unknown>
     */
    updated(changedProperties) {
        if (changedProperties.has('data')) {
            if (this.tooltip) {
                this.tooltip.option('contentTemplate', this.data.text);
            }
        }
    }
    render() {
        return html `
    <div id="tooltip-container">
      <span id=${this.idIcon} class="material-icons-round header-icon tooltip-icon">${this.data.icon}</span>
      <div id=${this.idTooltip} class="tool"></div>
    </div>
    `;
    }
};
__decorate([
    property({ type: String })
], DinapsisIconTooltip.prototype, "width", void 0);
__decorate([
    property()
], DinapsisIconTooltip.prototype, "data", void 0);
DinapsisIconTooltip = __decorate([
    customElement('dinapsis-icon-tooltip')
], DinapsisIconTooltip);
export { DinapsisIconTooltip };
//# sourceMappingURL=dinapsis-icon-tooltip.js.map